import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Gallery from './views/Gallery.vue';
import About from './views/About.vue';
import Contact from './views/Contact.vue';
import WeatherPrivacy from './views/WeatherPrivacy.vue';
import ContactTransferPrivacy from './views/ContactTransferPrivacy.vue';
import TOS from './views/TOS.vue';
import TOS2 from './views/TOS2.vue';
import TOSGPS from './views/TOSGPS.vue';
import PrivacyGPS from './views/PrivacyGPS.vue';
import Branding from './views/Branding.vue';
import Storage from './views/Storage.vue';
import Historical from './views/specialized/Historical.vue';
import Unsubscribe from './views/specialized/Unsubscribe.vue';
import AppPrivacyPolicy from './views/specialized/AppPrivacyPolicy.vue'
import AppTermsOfService from './views/specialized/AppTermsOfService.vue'
Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
      {
          path: '/',
          name: 'home',
          component: Home,
      },
      {
          path: '/about',
          name: 'About',
          component: About,
      },
      {
          path: '/contact',
          name: 'Contact',
          component: Contact,
      },
      {
          path: '/WeatherPrivacy',
          name: 'WeatherPrivacy',
          component: WeatherPrivacy,
      },
      {
          path: '/ContactTransferPrivacy',
          name: 'ContactTransferPrivacy',
          component: ContactTransferPrivacy,
      },
      {
          path: '/TOS',
          name: 'TOS',
          component: TOS,
      },
      {
          path: '/TOS2',
          name: 'TOS2',
          component: TOS2,
      },
      {
          path: '/TOSGPS',
          name: 'TOSGPS',
          component: TOSGPS,
      },
      
          {
              path: '/PrivacyGPS',
              name: 'PrivacyGPS',
              component: PrivacyGPS,
      },
      {
          path: '/specialized/historical',
          name: 'historical',
          component: Historical,
      },
      {
          path: '/specialized/AppPrivacyPolicy',
          name: 'AppPrivacyPolicy',
          component: AppPrivacyPolicy,
      },
      {
          path: '/specialized/AppTermsOfService',
          name: 'AppTermsOfService',
          component: AppTermsOfService,
      },
      {
          path: '/specialized/unsubscribe',
          name: 'unsubscribe',
          component: Unsubscribe,
      },

      {
      path: '/fetch-data',
      name: 'fetch-data',
      component: () => import(/* webpackChunkName: "fetch-data" */ './old_views/FetchData.vue'),
    },
  ],
});
